<template>
  <page-outline :title="$t('Webheader.config_routing')">
    <template slot="pageContent">

      <div class="listPage overflow-hidden">
        <b-row class="justify-content-start no-gutters">
          <b-button class="btn btnFilter mr-3" :disabled="activateSpinner"
            :aria-label="$t('common.rfrsh_settings')"
            @click="onRefresh">
            <i class="fa fa-rotate-right fs-14px"></i>
          </b-button>
          <div class="text-xl-center">
            <b-button-group class="d-none d-xl-inline-flex">
              <!-- <b-button class="config-buttons-title" :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0">{{ $t('common.routing.interprocess_config') }}</b-button>
              <b-button class="config-buttons-title" :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1">{{ $t('common.routing.mqseries_config') }}</b-button>
              <b-button class="config-buttons-title" :variant="tabName === 2 ? 'primary' : ''" @click="tabName = 2">{{ $t('common.routing.remotefolder_config') }}</b-button> -->
              <b-button v-if="webServiceConfigList.length" class="config-buttons-title" :variant="tabName === 3 ? 'primary' : ''" @click="tabName = 3">{{ $t('common.routing.webservice_config') }}</b-button>
              <b-button v-if="kafkaConfigList.length" class="config-buttons-title" :variant="tabName === 4 ? 'primary' : ''" @click="tabName = 4">{{ $t('common.routing.kafka_config') }}</b-button>
            </b-button-group>
            <b-button-group class="d-inline-flex d-xl-none">
              <!-- <b-button :variant="tabName === 0 ? 'primary' : ''" @click="tabName = 0">{{ $t('common.routing.inter_process') }}</b-button>
              <b-button :variant="tabName === 1 ? 'primary' : ''" @click="tabName = 1">{{ $t('common.routing.mqseries') }}</b-button>
              <b-button :variant="tabName === 2 ? 'primary' : ''" @click="tabName = 2">{{ $t('common.routing.remote_folder') }}</b-button> -->
              <b-button v-if="webServiceConfigList.length" :variant="tabName === 3 ? 'primary' : ''" @click="tabName = 3">{{ $t('common.routing.web_service') }}</b-button>
              <b-button v-if="kafkaConfigList.length" :variant="tabName === 4 ? 'primary' : ''" @click="tabName = 4">{{ $t('common.routing.kafka_config') }}</b-button>
            </b-button-group>
          </div>
        </b-row>

        <br />
        <b-tabs v-model="tabName" nav-class="d-none">
          <!-- INTERPROCESS LIST -->
          <b-tab :title="$t('common.routing.interprocess_config')">
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table fixed responsive
                    v-if="interProcessFields.length"
                    class="mt-3 table-striped"
                    :items="interProcessConfigList"
                    :fields="interProcessFields">
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <!-- MQSERIES LIST -->
          <b-tab>
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover relative responsive
                    v-if="mqseriesFields.length"
                    class="mt-3 table-striped"
                    :items="mqseriesConfigList"
                    :fields="mqseriesFields"
                    selectable select-mode="single" @row-selected="seeMQSeriesDetails">
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <!-- REMOTE FOLDER LIST -->
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover fixed responsive
                    v-if="remoteFolderFields.length"
                    class="mt-3 table-striped"
                    :items="remoteFolderConfigList"
                    :fields="remoteFolderFields"
                    selectable select-mode="single" @row-selected="seeRemoteFolderDetails">
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <!-- WEBSERCICE LIST -->
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover fixed responsive
                    v-if="webServiceFields.length"
                    class="mt-3 table-striped"
                    :items="webServiceConfigList"
                    :fields="webServiceFields"
                    selectable select-mode="single" @row-selected="seeWebServiceDetails">
                    <template #cell(Host)="data">
                      <span >{{ data.value }}</span>
                    </template>
                    <template #cell(URI)="data">
                      <div v-if="data.value.includes('|')">
                        <span>{{ $t('common.routing.multiple_uri') }}</span>
                      </div>
                      <span v-else >{{ data.value }}</span>
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <!-- KAFKA LIST -->
            <b-row>
              <b-col md="12">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else>
                  <b-table hover fixed responsive
                  v-if="kafkaFields.length"
                  class="mt-3 table-striped"
                  :items="kafkaConfigList"
                  :fields="kafkaFields"
                  selectable select-mode="single" @row-selected="seeKafkaDetails">
                  <template #cell(name)="data">
                    <span >{{ data.value }}</span>
                  </template>
                  <template #cell(Host)="data">
                    <div v-if="data.item.brokers.includes(',')">
                      <span>{{ $t('common.routing.multiple_uri') }}</span>
                    </div>
                    <span v-else >{{ getKafkaHost(data) }}</span>
                  </template>
                  <template #cell(Port)="data">
                    <div v-if="data.item.brokers.includes(',')">
                      <span>{{ $t('common.routing.multiple_port') }}</span>
                    </div>
                    <span v-else >{{ getKafkaPort(data) }}</span>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
          </b-tab>
        </b-tabs>
        <b-row class="justify-content-end mt-3 no-gutters" v-if="configType !== 'INTERPROCESS' && canAddConfig">
          <b-button
          @click="addConfig" variant="primary">
            <i class="fa-light fa-plus fs-17px"></i>
            <span>{{$t('common.routing.add_config')}}</span>
          </b-button>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
// import moment from 'moment'

import PageOutline from '@/components/common/PageOutline.vue'

import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'ConfigurationList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    type: {
      type: String,
      default: "WEBSERVICE"
    },
  },
  data () {
    return {
      activateSpinner: false,
      interProcessConfigList: [],
      kafkaConfigList: [],
      mqseriesConfigList: [],
      pageCounter: 0,
      remoteFolderConfigList: [],
      tabName: 3,
      webServiceConfigList: [],
    }
  },
  computed: {
    canAddConfig () {
      switch (this.configType) {
        case 'INTERPROCESS':
          return false
        case 'MQSERIES':
          return this.$engine.rights.rightIs('mqseriesConfig_ajouter', true)
        case 'REMOTEFOLDER':
          return this.$engine.rights.rightIs('remoteFolderConfig_ajouter', true)
        case 'WEBSERVICE':
          return this.$engine.rights.rightIs('webServiceConfig_ajouter', true)
        case 'KAFKA':
          return this.$engine.rights.rightIs('kafkaConfig_ajouter', true)
        default:
          return false
      }
    },
    configType () {
      if (this.tabName === 0) {
        return "INTERPROCESS"
      } else if (this.tabName === 1) {
        return "MQSERIES"
      } else if (this.tabName === 2) {
        return "REMOTEFOLDER"
      } else if (this.tabName === 3) {
        return "WEBSERVICE"
      } else if (this.tabName === 4) {
        return "KAFKA"
      } else {
        return "null"
      }
    },
    interProcessFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' }
      ]
    },
    mqseriesFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center' },
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center' },
        { key: 'ConnectionMode', label: this.$t('common.routing.connection_mode'), class: 'text-center' },
        { key: 'ConnectionType', label: this.$t('common.routing.connection_type'), class: 'text-center' },
        { key: 'QueueManager', label: this.$t('common.routing.queue_manager'), class: 'text-center' },
        { key: 'ChannelName', label: this.$t('common.routing.channel_name'), class: 'text-center' },
        { key: 'QueueName', label: this.$t('common.routing.queue_name'), class: 'text-center' }
      ]
    },
    remoteFolderFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center' },
        { key: 'Path', label: this.$t('common.routing.path'), class: 'text-center' }
      ]
    },
    webServiceFields () {
      return [
        { key: 'Name', label: this.$t('common.routing.config_name'), class: 'text-center align-middle' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center text-truncate align-middle' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center align-middle' },
        { key: 'URI', label: this.$t('common.routing.uri'), class: 'text-center text-truncate align-middle'},
        { key: 'SSLActive', label: this.$t('common.routing.ssl_active'), class: 'text-center text-truncate align-middle' }
      ]
    },
    kafkaFields () {
      return [
        { key: 'name', label: this.$t('common.routing.config_name'), class: 'text-center align-middle' },
        { key: 'Host', label: this.$t('common.routing.host'), class: 'text-center text-truncate align-middle' },
        { key: 'Port', label: this.$t('common.routing.port'), class: 'text-center align-middle' },
        { key: 'topic', label: this.$t('common.routing.topic'), class: 'text-center align-middle' },
      ]
    }
  },
  created () {

    if (this.type === "INTERPROCESS") {
      this.tabName = 0
    } else if (this.type === "MQSERIES") {
      this.tabName = 1
    } else if (this.type === "REMOTEFOLDER") {
      this.tabName = 2
    } else if (this.type === "WEBSERVICE") {
      this.tabName = 3
    } else if (this.type === "KAFKA") {
      this.tabName = 4
    }

    this.$f7.initPullToRefresh()
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    addConfig () {
      let that = this
      if(this.configType === "MQSERIES") {
        loadPage(that, {url: '/routing/mqseriesConfigurationDetails/create'})
      } else if(this.configType === "REMOTEFOLDER") {
        loadPage(that, {url: '/routing/remoteFolderConfigurationDetails/create'})
      } else if(this.configType === "WEBSERVICE") {
        loadPage(that, {url: '/routing/webServiceConfigurationDetails/create'})
      } else if (this.configType === "KAFKA") {
        // can't add config
        // loadPage(that, {url: '/routing/kafkaConfigurationDetails/create'})
      }
    },
    formattedUri (stringUri) {
      let splitIndex
      let uriArray = []
      Array.from(stringUri).forEach((char, index) => {
        if (index === 0) {
          splitIndex = 0
        }
        if (char === '|' || index === stringUri.length - 1) {
          let pathFound = index === stringUri.length - 1 ? stringUri.slice(splitIndex, index + 1) : stringUri.slice(splitIndex, index)
          uriArray.push(pathFound)
          splitIndex = index + 1
        }
      })
      return uriArray
    },
    getConfigInterProcess () {
      let that = this
      this.$engine.routing.config.interProcess.fetch(
        {}
      ).then(resp => {
        let interProcessList = {}

        interProcessList = resp.data.InterProcesses

        this.updateInterProcess(interProcessList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    },
    getConfigKafka () {
      let that = this
      let params = {}
      this.$engine.routing.config.kafka.fetch(params).
      then(resp => {
        let kafkaList = resp.data.configKafka

        this.updateKafka(kafkaList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    },
    getConfigMQSeries () {
      let that = this
      this.$engine.routing.config.mqseries.fetch(
        {}
      ).then(resp => {
        let mqseriesList = {}

        mqseriesList = resp.data.MQSeries

        this.updatemqseries(mqseriesList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    },
    getConfigRemoteFolder () {
      let that = this
      this.$engine.routing.config.remoteFolder.fetch(
        {}
      ).then(resp => {
        let remoteFolderList = {}

        remoteFolderList = resp.data.RemoteFolder

        this.updateRemoteFolders(remoteFolderList)
        this.activateSpinner = false

        this.$f7.pullToRefreshDone()
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    },

    /*
        this.$engine.routing.config.webService.fetch(
      {}
    ).then(resp => {
      let webServiceList = {}

      webServiceList = resp.data.WebService

      this.updateWebServices(webServiceList)
    })
  },*/
    getConfigWebService () {
      if (this.tabName === 3) {
        this.activateSpinner = true
      }
      this.$engine.routing.config.webService.fetch({})
      .then(resp => {
        let webServiceList = {}
        webServiceList = resp.data.WebService
        that.updateWebServices(webServiceList)
        if (that.tabName === 3) {
          that.activateSpinner = false
        }
      })
      .catch(err => {
        if (that.tabName === 3) {
          that.activateSpinner = false
        }
        errorMessageAlert(err, that, true)
      })
      let that=this
      that.$f7.pullToRefreshDone()
    },
    getKafkaHost (data) {
      return data.item.brokers && data.item.brokers.split(':').length ? data.item.brokers.split(':')[0] : ''
    },
    getKafkaPort (data) {
      return data.item.brokers && data.item.brokers.split(':').length > 1 ? data.item.brokers.split(':')[1] : ''
    },
    onRefresh () {
      this.activateSpinner = true
      this.pageCounter = 0

      // this.getConfigInterProcess()
      // this.getConfigMQSeries()
      // this.getConfigRemoteFolder()
      this.getConfigWebService()
      this.getConfigKafka()

      this.$f7.pullToRefreshDone()
    },
    seeKafkaDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/kafkaConfigurationDetails/details'})
    },
    seeMQSeriesDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/mqseriesConfigurationDetails/details'})
    },
    seeRemoteFolderDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/remoteFolderConfigurationDetails/details'})
    },
    seeWebServiceDetails (items) {
      let config = items[0]
      let that = this

      this.$engine.routing.config.clickedConfig = config
      loadPage(that, {url: '/routing/webServiceConfigurationDetails/details'})
    },
    updateInterProcess (interProcessList) {
      this.interProcessConfigList = interProcessList
    },
    updateKafka (kafkaList) {
      let that = this
      this.kafkaConfigList = kafkaList
      this.kafkaConfigList.forEach(kafka=> {
        if(kafka.SSLActive === "1") {
          kafka.SSLActive = that.$t('common.routing.yes')
        } else {
          kafka.SSLActive = that.$t('common.routing.no')
        }
      })
    },
    updatemqseries (mqseriesList) {
      let that = this
      this.mqseriesConfigList = mqseriesList
      this.mqseriesConfigList.forEach(mqseries=> {
        if(mqseries.SSL === '1') {
          mqseries.SSLActive = that.$t('common.routing.yes')
        } else {
          mqseries.SSLActive = that.$t('common.routing.no')
        }
      })
    },
    updateRemoteFolders (remoteFolderList) {
      this.remoteFolderConfigList = remoteFolderList
    },
    updateWebServices (webServiceList) {
      let that = this
      this.webServiceConfigList = webServiceList
      this.webServiceConfigList.forEach(webService=> {
        if(webService.SSLMode === "1") {
          webService.SSLActive = that.$t('common.routing.yes')
        } else {
          webService.SSLActive = that.$t('common.routing.no')
        }
      })
      if (!this.webServiceConfigList.length) {
        this.tabName = 4
      }
    }
  }
}
</script>
